import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardWaitingQueueListUX = (props: any) => {
    return(
      <div
        id="CardWaitingQueueListUX-div-0"
        style={{padding: "10px"}}>
        
        <div
          id="CardWaitingQueueListUX-div-3">
          
          <Form
            id="CardWaitingQueueListUX-Form-2">
            <FormGroup
              id="CardWaitingQueueListUX-FormGroup-4"
              style={{display: "flex", alignItems:"flex-end"}}>
              <FormField
                id="CardWaitingQueueListUX-FormField-5"
                style={{width: "220px"}}>
                <label
                  id="CardWaitingQueueListUX-label-13">
                  {props.languageUX === "en" ? "Name - Surname / HN" : "ชื่อ - สกุล / HN"}
                </label>
                <div
                  id="CardWaitingQueueListUX-div-44">
                  {props.patientSearchCU}
                </div>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-6">
                <label
                  id="CardWaitingQueueListUX-label-14">
                  {props.languageUX === "en" ? "Queue number" : "เลขที่คิว"}
                </label>
                <Input
                  id="CardWaitingQueueListUX-Input-22"
                  onChange={props.onChangeQueueNo}
                  value={props.queueNo}>
                </Input>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-7"
                style={{width: "300px"}}>
                <label
                  id="CardWaitingQueueListUX-label-15">
                  {props.languageUX === "en" ? "Clinics with queues" : "คลินิกที่เข้าคิว"}
                </label>
                <Dropdown
                  disabled={props.disabledWaitingListDivision}
                  fluid={true}
                  id="CardWaitingQueueListUX-Dropdown-23"
                  onChange={props.onChangeWaitingListDivision}
                  options={props.divisionHasWaitingListOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.selectedWaitingListDivisionId??""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-8">
                <label
                  id="CardWaitingQueueListUX-label-16">
                  {props.languageUX === "en" ? "Work group name" : "ชื่อกลุ่มงาน"}
                </label>
                <Dropdown
                  disabled={props.disabledSelectedWaitingList}
                  id="CardWaitingQueueListUX-Dropdown-24"
                  onChange={props.onChangeSelectedWaitingList}
                  options={props.waitingListOptions}
                  search={true}
                  selection={true}
                  value={props.selectedWaitingList}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-9">
                <label
                  id="CardWaitingQueueListUX-label-17">
                  {props.languageUX === "en" ? "status" : "สถานะ"}
                </label>
                <Dropdown
                  disabled={props.disabledSelectedStatus}
                  id="CardWaitingQueueListUX-Dropdown-25"
                  onChange={props.onChangeSelectedStatus}
                  options={props.waitingListStatusOptions}
                  selection={true}
                  value={props.selectedWaitingStatus}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-43"
                style={{display:"flex", alignItems:"flex-end",marginBottom:"1px", marginLeft: "1px"}}>
                <Button
                  color="teal"
                  content="ออกจากสรุปรายชื่อคิว"
                  icon="window close outline"
                  id="CardWaitingQueueListUX-Button-1"
                  labelPosition="right"
                  onClick={props.exitQueueList}>
                  
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardWaitingQueueListUX-FormGroup-41"
              style={{display:"flex",alignItems:"flex-end"}}>
              <FormField
                id="CardWaitingQueueListUX-FormField-10">
                <label
                  id="CardWaitingQueueListUX-label-18">
                  {props.languageUX === "en" ? "Queuing date" : "วันที่เข้าคิว"}
                </label>
                <DateTextBox
                  id="CardWaitingQueueListUX-DateTextBox-26"
                  onChange={props.onChangeStartDateQL}
                  value={props.startDateQL}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-11">
                <label
                  id="CardWaitingQueueListUX-label-19">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
                <DateTextBox
                  id="CardWaitingQueueListUX-DateTextBox-27"
                  onChange={props.onChangeEndDateQL}
                  value={props.endDateQL}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-12"
                style={{width: "270px"}}>
                <label
                  id="CardWaitingQueueListUX-label-20">
                  {props.languageUX === "en" ? "Dentist / Student" : "ทันตแพทย์ / นิสิต"}
                </label>
                <div
                  id="CardWaitingQueueListUX-div-45">
                  {props.doctorSelector}
                </div>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-50">
                <Checkbox
                  checked={props.waitingListQLNoDoctor}
                  id="CardWaitingQueueListUX-Checkbox-51"
                  label={props.languageUX === "en" ? "Show only unspecified doctors" : "แสดงเฉพาะไม่กำหนดแพทย์"}
                  onChange={props.onChangeWaitingListQLNoDoctor}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardWaitingQueueListUX-FormGroup-49"
              style={{display: "flex", alignItems:"flex-end"}}>
              <FormField
                id="CardWaitingQueueListUX-FormField-29">
                <label
                  id="CardWaitingQueueListUX-label-33">
                  {props.languageUX === "en" ? "Complete Date" : "วันที่ Complete"}
                </label>
                <DateTextBox
                  id="CardWaitingQueueListUX-DateTextBox-37"
                  onChange={props.onChangeCompleteStartDateQL}
                  value={props.completeStartDateQL}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-46">
                <label
                  id="CardWaitingQueueListUX-label-47">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
                <DateTextBox
                  id="CardWaitingQueueListUX-DateTextBox-48"
                  onChange={props.onChangeCompleteEndDateQL}
                  value={props.completeEndDateQL}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-30"
                style={{display:"flex", alignItems:"flex-end",marginBottom:"1px"}}>
                <Button
                  color="blue"
                  id="CardWaitingQueueListUX-Button-38"
                  onClick={props.onClickSearch}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-31"
                style={{display:"flex", alignItems:"flex-end",marginBottom:"1px"}}>
                <Button
                  color="orange"
                  id="CardWaitingQueueListUX-Button-39"
                  onClick={props.onClickPrint}>
                  {props.languageUX === "en" ? "print" : "พิมพ์"}
                </Button>
              </FormField>
              <FormField
                id="CardWaitingQueueListUX-FormField-32"
                style={{display:"flex", alignItems:"flex-end",marginBottom:"1px"}}>
                <Button
                  color="green"
                  id="CardWaitingQueueListUX-Button-40"
                  onClick={props.onClickDownload}>
                  {props.languageUX === "en" ? "Download .xlsx" : "ดาวน์โหลด .xlsx"}
                </Button>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardWaitingQueueListUX-div-42">
          {props.tableQueueList}
        </div>
        <div
          id="CardWaitingQueueListUX-div-52"
          style={{marginTop: "2px",textAlign: "right"}}>
          {props.pagination}
        </div>
      </div>
    )
}


export default CardWaitingQueueListUX

export const screenPropsDefault = {"title":"9:00-12:00"}

/* Date Time : Fri Oct 31 2025 04:29:41 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "content": {
          "type": "value",
          "value": "ออกจากสรุปรายชื่อคิว"
        },
        "icon": {
          "type": "value",
          "value": "window close outline"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Button-1"
        },
        "labelPosition": {
          "type": "value",
          "value": "right"
        },
        "onClick": {
          "type": "code",
          "value": "props.exitQueueList"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Form-2"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-3"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormGroup-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems:\"flex-end\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-5"
        },
        "style": {
          "type": "code",
          "value": "{width: \"220px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-7"
        },
        "style": {
          "type": "code",
          "value": "{width: \"300px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{width: \"270px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - สกุล / HN",
          "valueEN": "Name - Surname / HN"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่คิว",
          "valueEN": "Queue number"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิกที่เข้าคิว",
          "valueEN": "Clinics with queues"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อกลุ่มงาน",
          "valueEN": "Work group name"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เข้าคิว",
          "valueEN": "Queuing date"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ทันตแพทย์ / นิสิต",
          "valueEN": "Dentist / Student"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Input-22"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeQueueNo"
        },
        "value": {
          "type": "code",
          "value": "props.queueNo"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Dropdown",
      "parent": 7,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledWaitingListDivision"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Dropdown-23"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWaitingListDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionHasWaitingListOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedWaitingListDivisionId??\"\""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledSelectedWaitingList"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Dropdown-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSelectedWaitingList"
        },
        "options": {
          "type": "code",
          "value": "props.waitingListOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedWaitingList"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "clearable": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSelectedStatus"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Dropdown-25"
        },
        "multiple": {
          "type": "code",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSelectedStatus"
        },
        "options": {
          "type": "code",
          "value": "props.waitingListStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedWaitingStatus"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 26,
      "name": "DateTextBox",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-DateTextBox-26"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDateQL"
        },
        "value": {
          "type": "code",
          "value": "props.startDateQL"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 27,
      "name": "DateTextBox",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-DateTextBox-27"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDateQL"
        },
        "value": {
          "type": "code",
          "value": "props.endDateQL"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-29"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-30"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", alignItems:\"flex-end\",marginBottom:\"1px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-31"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", alignItems:\"flex-end\",marginBottom:\"1px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-32"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", alignItems:\"flex-end\",marginBottom:\"1px\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ Complete",
          "valueEN": "Complete Date"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 37,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-DateTextBox-37"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCompleteStartDateQL"
        },
        "value": {
          "type": "code",
          "value": "props.completeStartDateQL"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Button",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Button-38"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSearch"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Button",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์",
          "valueEN": "print"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Button-39"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickPrint"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Button",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "ดาวน์โหลด .xlsx",
          "valueEN": "Download .xlsx"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Button-40"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDownload"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormGroup-41"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",alignItems:\"flex-end\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableQueueList"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-43"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", alignItems:\"flex-end\",marginBottom:\"1px\", marginLeft: \"1px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearchCU"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-44"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSelector"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-45"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-46"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 48,
      "name": "DateTextBox",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-DateTextBox-48"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCompleteEndDateQL"
        },
        "value": {
          "type": "code",
          "value": "props.completeEndDateQL"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormGroup-49"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems:\"flex-end\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-FormField-50"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Checkbox",
      "parent": 50,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.waitingListQLNoDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-Checkbox-51"
        },
        "label": {
          "type": "value",
          "value": "แสดงเฉพาะไม่กำหนดแพทย์",
          "valueEN": "Show only unspecified doctors"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWaitingListQLNoDoctor"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardWaitingQueueListUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2px\",textAlign: \"right\"}"
        }
      },
      "seq": 52,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardWaitingQueueListUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "title": "9:00-12:00"
  },
  "width": 80
}

*********************************************************************************** */
